import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

export default function TeacherDashboard() {
  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="bg-white rounded-lg shadow p-6 max-w-5xl mx-auto">
        <h1 className="text-2xl font-bold mb-6 text-gray-800">👩‍🏫 Teacher Dashboard</h1>

        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-indigo-100 p-4 rounded-lg text-center">
            <h2 className="text-lg font-semibold text-indigo-800">Live Sessions</h2>
            <p className="text-sm mt-1">Manage your classes</p>
            <Link to="/teacher/CreateClass">
              <button className="mt-3 bg-indigo-600 hover:bg-indigo-700 text-white py-1 px-4 rounded">
                Sessions
              </button>
            </Link>
          </div>

          <div className="bg-purple-100 p-4 rounded-lg text-center">
            <h2 className="text-lg font-semibold text-purple-800">Materials</h2>
            <p className="text-sm mt-1">Post and review materials</p>
            <Link to="/teacher/post-material">
              <button className="mt-3 bg-purple-600 hover:bg-purple-700 text-white py-1 px-4 rounded">
                Materials
              </button>
            </Link>
          </div>

          <div className="bg-pink-100 p-4 rounded-lg text-center">
            <h2 className="text-lg font-semibold text-pink-800">Ratings</h2>
            <p className="text-sm mt-1">Student feedback</p>
            <Link to="/teacher/ratings">
              <button className="mt-3 bg-pink-600 hover:bg-pink-700 text-white py-1 px-4 rounded">
                Ratings
              </button>
            </Link>
          </div>
        </div>

        <div className="mt-6">
          <h3 className="text-lg font-medium mb-2">Quick Stats</h3>
          <ul className="space-y-1 text-sm text-gray-700 max-w-xs mx-auto">
            <li>👨‍🎓 Students Enrolled: 120</li>
            <li>📚 Materials Posted: 35</li>
            <li>⭐ Avg Rating: 4.8</li>
            <li>🧾 Appointed Classes: 8</li>
            <li>💰 Wallet Balance: 310 Coins</li>
          </ul>

        </div>
      </div>
    
    </div>
      
  );
}
